import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Headers = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [servicesSubmenuOpen, setServicesSubmenuOpen] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  // Prevent body scrolling when mobile menu is open
  useEffect(() => {
    if (isNavOpen) {
      document.body.classList.add("hc-nav-open");
    } else {
      document.body.classList.remove("hc-nav-open");
    }
    return () => {
      document.body.classList.remove("hc-nav-open");
    };
  }, [isNavOpen]);

  const openNav = () => setIsNavOpen(true);
  const closeNav = () => setIsNavOpen(false);

  const toggleServicesSubmenu = (e) => {
    e.preventDefault();
    setServicesSubmenuOpen((prev) => !prev);
  };

  return (
    <>
      {/* Loader */}
      {isLoading && (
        <div className="onloadpage" id="page-load">
          <div className="loader-div">
            <div className="on-img">
              <img
                src="images/loader.gif"
                alt="Loading..."
                className="img-fluid"
                style={{ width: "80px", height: "80px" }}
              />
              <span style={{ marginTop: "0.5rem" }}>
                Loading Please Wait...
              </span>
            </div>
          </div>
        </div>
      )}

      {/* Off-canvas navigation menu (mobile) */}
      <nav
        id="hc-nav-1"
        className={`hc-offcanvas-nav hc-nav-1 nav-levels-overlap nav-position-left disable-body touch-device nav-close-button-empty ${
          isNavOpen ? "nav-open" : ""
        }`}
        aria-hidden={!isNavOpen}
        aria-labelledby="hc-nav-1-nav-title"
        style={{ visibility: isNavOpen ? "visible" : "hidden" }}
      >
        <div
          className="nav-container"
          style={{
            transform: servicesSubmenuOpen
              ? "translate3d(40px, 0px, 0px)"
              : isNavOpen
                ? "translate3d(0px, 0px, 0px)"
                : "translate3d(0px, 0px, 0px)",
          }}
        >
          <div
            className={`nav-wrapper nav-wrapper-0 ${servicesSubmenuOpen ? "sub-level-open" : ""}`}
            data-level="0"
            data-index="0"
          >
            <div className="nav-content">
              <h2 id="hc-nav-1-nav-title" className="nav-title">
                Menu DVELGE
              </h2>
              <div className="nav-close">
                <a
                  href="#"
                  className="nav-close-button"
                  role="menuitem"
                  tabIndex="0"
                  aria-label="Close Menu"
                  onClick={(e) => {
                    e.preventDefault();
                    closeNav();
                  }}
                >
                  <span></span>
                </a>
              </div>

              {/* Main navigation links */}
              <ul role="menu" aria-level="1">
                <li className="nav-item">
                  <div className="nav-item-wrapper">
                    <Link
                      to="/"
                      className="nav-item-link"
                      tabIndex="0"
                      role="menuitem"
                      onClick={closeNav}
                    >
                      Accueil
                    </Link>
                  </div>
                </li>
                <li className="nav-item">
                  <div className="nav-item-wrapper">
                    <Link
                      to="/apropos"
                      className="nav-item-link"
                      tabIndex="0"
                      role="menuitem"
                      onClick={closeNav}
                    >
                      A propos
                    </Link>
                  </div>
                </li>

                {/* Services with submenu */}
                <li
                  className={`nav-item nav-parent ${servicesSubmenuOpen && `level-open`} `}
                >
                  <input
                    type="checkbox"
                    id="hc-nav-1-services"
                    className="hc-chk"
                    tabIndex={-1}
                    data-level="1"
                    data-index="2"
                    checked={servicesSubmenuOpen}
                    onChange={() => {}} // controlled by link click
                  />
                  <div className="nav-item-wrapper">
                    <a
                      href="#"
                      className="nav-item-link"
                      tabIndex="0"
                      role="menuitem"
                      aria-controls="menu-services"
                      aria-haspopup="true"
                      aria-expanded={servicesSubmenuOpen}
                      onClick={toggleServicesSubmenu}
                    >
                      Services
                      <span className="nav-next">
                        <span></span>
                      </span>
                    </a>
                  </div>
                  <div
                    className="nav-wrapper nav-wrapper-1"
                    data-level="1"
                    data-index="2"
                  >
                    <div className="nav-content">
                      <h2 className="level-title">Services</h2>
                      <div className="nav-back">
                        <div className="nav-item-wrapper">
                          <a
                            href="#"
                            className="nav-back-button"
                            role="menuitem"
                            tabIndex="0"
                            onClick={(e) => {
                              e.preventDefault();
                              setServicesSubmenuOpen(false);
                            }}
                          >
                            Menu DVELGE<span></span>
                          </a>
                        </div>
                      </div>
                      <ul id="menu-services" role="menu" aria-level="2">
                        <li className="nav-item">
                          <div className="nav-item-wrapper">
                            <Link
                              to="https://fourniture.dvelgegroup.com"
                              className="nav-item-link"
                              tabIndex="0"
                              role="menuitem"
                              onClick={closeNav}
                            >
                              Fourniture
                            </Link>
                          </div>
                        </li>
                        <li className="nav-item">
                          <div className="nav-item-wrapper">
                            <Link
                              to="https://logiciel.dvelgegroup.com"
                              className="nav-item-link"
                              tabIndex="0"
                              role="menuitem"
                              onClick={closeNav}
                            >
                              Logiciel
                            </Link>
                          </div>
                        </li>
                        <li className="nav-item">
                          <div className="nav-item-wrapper">
                            <Link
                              to="https://formation.dvelgegroup.com"
                              className="nav-item-link"
                              tabIndex="0"
                              role="menuitem"
                              onClick={closeNav}
                            >
                              Formation
                            </Link>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>

                <li className="nav-item">
                  <div className="nav-item-wrapper">
                    <Link
                      to="/projets"
                      className="nav-item-link"
                      tabIndex="0"
                      role="menuitem"
                      onClick={closeNav}
                    >
                      Projets
                    </Link>
                  </div>
                </li>
                <li className="nav-item">
                  <div className="nav-item-wrapper">
                    <Link
                      to="/blogs"
                      className="nav-item-link"
                      tabIndex="0"
                      role="menuitem"
                      onClick={closeNav}
                    >
                      Blog
                    </Link>
                  </div>
                </li>
                <li className="nav-item">
                  <div className="nav-item-wrapper">
                    <Link
                      to="/contacts"
                      className="nav-item-link"
                      tabIndex="0"
                      role="menuitem"
                      onClick={closeNav}
                    >
                      Contacts
                    </Link>
                  </div>
                </li>
                <li className="nav-item">
                  <div className="nav-item-wrapper">
                    <Link
                      to="/carrieres"
                      className="nav-item-link"
                      tabIndex="0"
                      role="menuitem"
                      onClick={closeNav}
                    >
                      Carrieres
                    </Link>
                  </div>
                </li>
              </ul>

              {/* Bottom contact icons */}
              <ul role="menu" aria-level="1" className="bottom-nav">
                <li className="nav-item ree-hc">
                  <div className="nav-item-wrapper">
                    <a
                      href="tel:+224627020871"
                      rel="noreferrer"
                      target="_blank"
                      className="nav-item-link"
                      tabIndex="0"
                      role="menuitem"
                    >
                      <svg
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        viewBox="0 0 25.625 25.625"
                        xmlSpace="preserve"
                      >
                        <g>
                          <path d="M22.079,17.835c-1.548-1.324-3.119-2.126-4.648-0.804l-0.913,0.799 c-0.668,0.58-1.91,3.29-6.712-2.234C5.005,10.079,7.862,9.22,8.531,8.645l0.918-0.8c1.521-1.325,0.947-2.993-0.15-4.71l-0.662-1.04 C7.535,0.382,6.335-0.743,4.81,0.58L3.986,1.3C3.312,1.791,1.428,3.387,0.971,6.419c-0.55,3.638,1.185,7.804,5.16,12.375 c3.97,4.573,7.857,6.87,11.539,6.83c3.06-0.033,4.908-1.675,5.486-2.272l0.827-0.721c1.521-1.322,0.576-2.668-0.973-3.995 L22.079,17.835z" />
                        </g>
                      </svg>
                    </a>
                  </div>
                </li>
                <li className="nav-item ree-hc">
                  <div className="nav-item-wrapper">
                    <a
                      href="mailto:ventes@dvelgegroup.com"
                      target="_blank"
                      className="nav-item-link"
                      tabIndex="0"
                      role="menuitem"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                        <path d="M0 0h24v24H0z" fill="none" />
                      </svg>
                    </a>
                  </div>
                </li>
                <li className="nav-item ree-hc">
                  <div className="nav-item-wrapper">
                    <a
                      href="https://wa.me/+224627020871"
                      rel="noreferrer"
                      target="_blank"
                      className="nav-item-link"
                      tabIndex="0"
                      role="menuitem"
                    >
                      <svg
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        viewBox="0 0 512 512"
                        xmlSpace="preserve"
                      >
                        <g>
                          <path d="M256.064,0h-0.128C114.784,0,0,114.816,0,256c0,56,18.048,107.904,48.736,150.048l-31.904,95.104l98.4-31.456 C155.712,496.512,204,512,256.064,512C397.216,512,512,397.152,512,256S397.216,0,256.064,0z M405.024,361.504 c-6.176,17.44-30.688,31.904-50.24,36.128c-13.376,2.848-30.848,5.12-89.664-19.264C189.888,347.2,141.44,270.752,137.664,265.792 c-3.616-4.96-30.4-40.48-30.4-77.216s18.656-54.624,26.176-62.304c6.176-6.304,16.384-9.184,26.176-9.184 c3.168,0,6.016,0.16,8.576,0.288c7.52,0.32,11.296,0.768,16.256,12.64c6.176,14.88,21.216,51.616,23.008,55.392 c1.824,3.776,3.648,8.896,1.088,13.856c-2.4,5.12-4.512,7.392-8.288,11.744c-3.776,4.352-7.36,7.68-11.136,12.352 c-3.456,4.064-7.36,8.416-3.008,15.936c4.352,7.36,19.392,31.904,41.536,51.616c28.576,25.44,51.744,33.568,60.032,37.024 c6.176,2.56,13.536,1.952,18.048-2.848c5.728-6.176,12.8-16.416,20-26.496c5.12-7.232,11.584-8.128,18.368-5.568 c6.912,2.4,43.488,20.48,51.008,24.224c7.52,3.776,12.48,5.568,14.304,8.736C411.2,329.152,411.2,344.032,405.024,361.504z" />
                        </g>
                      </svg>
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>

      {/* Overlay when mobile menu is open */}
      {isNavOpen && (
        <div className="offcanvas-overlay" onClick={closeNav}></div>
      )}

      {/* Header principal (desktop) */}
      <header className="ree-header fixed-top">
        <div className="container-fluid m-p-l-r-0">
          <div className="menu-header">
            {/* Logo */}
            <div className="menu-logo">
              <div className="dskt-logo">
                <Link className="nav-brand" to="/">
                  <img src="images/logo.png" alt="Logo" className="ree-logo" />
                </Link>
              </div>
            </div>

            {/* Desktop navigation */}
            <div className="ree-nav" role="navigation">
              <ul className="nav-list">
                <li className="megamenu">
                  <Link to="/" className="menu-links">
                    Accueil
                  </Link>
                </li>
                <li className="megamenu">
                  <Link to="/apropos" className="menu-links">
                    A propos
                  </Link>
                </li>
                <li className="megamenu mega-small">
                  <Link to="/services" className="menu-links">
                    Services
                  </Link>
                  <div className="menu-dropdown">
                    <div className="menu-block-set">
                      <a
                        className="dropdown-item"
                        href="https://fourniture.dvelgegroup.com"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Fourniture
                      </a>
                      <a
                        className="dropdown-item"
                        href="https://logiciel.dvelgegroup.com"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Logiciel
                      </a>
                      <a
                        className="dropdown-item"
                        href="https://formation.dvelgegroup.com"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Formation
                      </a>
                    </div>
                  </div>
                </li>
                <li className="megamenu">
                  <Link to="/projets" className="menu-links">
                    Projets
                  </Link>
                </li>
                <li className="megamenu">
                  <Link to="/blogs" className="menu-links">
                    Blog
                  </Link>
                </li>
                <li className="megamenu">
                  <Link to="/contacts" className="menu-links">
                    Contacts
                  </Link>
                </li>
                <li className="megamenu">
                  <Link to="/carrieres" className="menu-links">
                    Carrieres
                  </Link>
                </li>
              </ul>
            </div>

            {/* Call-to-Action button */}
            <div className="ree-nav-cta">
              <ul>
                <li>
                  <Link
                    to="/contacts"
                    className="ree-btn ree-btn0 ree-btn-grdt2"
                  >
                    Demander un Devis
                  </Link>
                </li>
              </ul>
            </div>

            {/* Mobile menu toggle */}
            <div className="mobile-menu2">
              <ul className="mob-nav2">
                <li>
                  <Link to="/contacts" className="ree-btn2 ree-btn-grdt1">
                    <i className="fas fa-envelope-open-text"></i>
                  </Link>
                </li>
                <li className="navm-">
                  <a
                    className={`toggle hc-nav-trigger hc-nav-1 ${
                      isNavOpen ? "toggle-open" : ""
                    }`}
                    href="#"
                    role="button"
                    aria-label="Open Menu"
                    aria-controls="hc-nav-1"
                    aria-expanded={isNavOpen}
                    onClick={(e) => {
                      e.preventDefault();
                      openNav();
                    }}
                  >
                    <span></span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Headers;
